import { Router } from '@angular/router';
import { WarehouseLocationInventoryDetail, WarehouseLocationInventoryInquiry, WarehouseLocationInventoryInquiryService } from './../../acumatica/EntityServices/WarehouseLocationInventoryInquiry.service';
import { MayerFabricsService } from 'src/app/services/mayer-fabrics.service';
import { Component, OnInit } from '@angular/core';
import { ApplicationScreen } from 'src/app/application-navigator/application-screen';
import { ItemType, StockItem } from 'src/app/acumatica/EntityServices/StockItem.service';

@Component({
  selector: 'app-rep-inventory',
  templateUrl: './rep-inventory.component.html',
  styleUrls: ['./rep-inventory.component.css']
})
export class RepInventoryComponent extends ApplicationScreen implements OnInit {
  pageTitle = "My Inventory";
  // inventory?: legacy_InventoryRow[];

  inventoryBinders: InventoryRow[] = [];
  inventoryCards: InventoryRow[] = [];
  inventorySupplies: InventoryRow[] = [];
  inventoryOther: InventoryRow[] = [];
  inventories = [this.inventoryBinders, this.inventoryCards, this.inventorySupplies, this.inventoryOther];

  inventoryMemos: { [key: string]: InventoryRow[] } = {};
  get hasMemos(): boolean { return Object.keys(this.inventoryMemos).length > 0; }

  tableColumnsToDisplay = ['InventoryID', 'Description', 'Qty'];

  constructor(
    private inventoryInquiry: WarehouseLocationInventoryInquiryService,
    private mayerfabrics: MayerFabricsService,
    private router: Router
  ) {
    super();

    let whseID = this.mayerfabrics.RepWarehouseID;
    if (!whseID) { this.router.navigate(['/']); return }
  }

  ngOnInit(): void {
    let whseID = this.mayerfabrics.RepWarehouseID;
    if (!whseID) return;

    this.inventoryInquiry.get(
      new WarehouseLocationInventoryInquiry({
        WarehouseID: whseID,
        LocationID: 'MAIN'
      }), { loader: "Checking Inventory" }
    ).subscribe(inquiryResult => {
      inquiryResult.Details
        .map(row => row as InventoryRow)
        .forEach(row => {
          row.ItemType = StockItem.getItemType(row.LotSerialClass!, row.ItemClassID!, row.InventoryID!, row.Description!);
          if (!row.PatternDescription) row.PatternDescription = row.Description || null;

          switch (row.ItemType) {
            case ItemType.FullCardBinder:
              this.inventoryBinders.push(row);
              break;
            case ItemType.EmptyBinderShell:
              this.inventoryBinders.push(row);
              break;
            case ItemType.SampleCard:
              this.inventoryCards.push(row);
              break;
            case ItemType.MemoSample:
            case ItemType.CollatedSet:
            case ItemType.TagSet:
              // memo items are separated by pattern into individual array collections
              let patternID = (row.PatternDescription + ' (' + row.PatternClassID + ')') || '(unknown)';
              if (this.inventoryMemos[patternID] === undefined) this.inventoryMemos[patternID] = [];
              this.inventoryMemos[patternID].push(row);
              break;
            case ItemType.Supplies:
              this.inventorySupplies.push(row);
              break;
            case ItemType.Unspecified:
              this.inventoryOther.push(row);
              break;
          }
        });

      // sort each inventory arrays
      this.inventories.forEach(inventory => {
        inventory.sort((a: InventoryRow, b: InventoryRow) => {
          if (a.ItemType == ItemType.EmptyBinderShell && b.ItemType == ItemType.FullCardBinder) return -1;
          if (a.ItemType == ItemType.FullCardBinder && b.ItemType == ItemType.EmptyBinderShell) return 1;
          return a.Description!.localeCompare(b.Description!);
        });
      });

      // sort the memo sub-inventory arrays
      Object.values(this.inventoryMemos).forEach(inventory => inventory.sort((a, b) => a.Description!.localeCompare(b.Description!)));
    })
  }

  // legacy_processInventoryData(inquiryResult: WarehouseLocationInventoryInquiry) {

  //   // sort and group results
  //   const sorted = inquiryResult.Details
  //     // exclude memo samples
  //     .filter(detail => detail.ItemClassID!.trim() != '50')
  //     // cast rows to InventoryRow and populate the Item Type
  //     .map(detail => {
  //       let row = detail as legacy_InventoryRow;
  //       row.ItemType = StockItem.getItemType(row.LotSerialClass!, row.ItemClassID!, row.InventoryID!, row.Description!);
  //       if (!row.PatternDescription) row.PatternDescription = row.Description || null;
  //       return row;
  //     })
  //     // sort rows
  //     .sort((a, b) => {
  //       let aGroupIdx: number;
  //       let bGroupIdx: number;

  //       // determine sorting indicator for group
  //       switch (a.ItemType) {
  //         case ItemType.FullCardBinder: aGroupIdx = 0; break;
  //         case ItemType.EmptyBinderShell: aGroupIdx = 1; break;
  //         case ItemType.SampleCard: aGroupIdx = 2; break;
  //         default: aGroupIdx = 3;
  //       }
  //       switch (b.ItemType) {
  //         case ItemType.FullCardBinder: bGroupIdx = 0; break;
  //         case ItemType.EmptyBinderShell: bGroupIdx = 1; break;
  //         case ItemType.SampleCard: bGroupIdx = 2; break;
  //         default: bGroupIdx = 3;
  //       }

  //       // different groups, return sorting indicator based on group order
  //       if (aGroupIdx != bGroupIdx) return aGroupIdx - bGroupIdx;

  //       // same group -- for binders, sort by Inventory ID
  //       if (a.ItemType == ItemType.EmptyBinderShell || a.ItemType == ItemType.FullCardBinder)
  //         return a.InventoryID!.localeCompare(b.InventoryID!);

  //       // same group -- cards, sort by Pattern Class Description
  //       const aDesc = a.PatternDescription || '';
  //       const bDesc = b.PatternDescription || '';

  //       // same group, same pattern class -- sort by Item Description
  //       if (aDesc == bDesc) return a.Description!.localeCompare(b.Description!);

  //       return aDesc.localeCompare(bDesc);
  //     });

  //   // inject grouping headers
  //   this.inventory = [];
  //   let lastGroupHeader: string | null = null;
  //   sorted.forEach(row => {
  //     const thisGroupHeader = StockItem.getItemTypeDescription(row.ItemType!);
  //     if (thisGroupHeader != lastGroupHeader) {
  //       this.inventory!.push(new legacy_InventoryRow({
  //         RowHeader: thisGroupHeader
  //       }));
  //       lastGroupHeader = thisGroupHeader;
  //     }

  //     this.inventory!.push(row);
  //   });
  // }
}

class InventoryRow extends WarehouseLocationInventoryDetail {
  ItemType?: ItemType;
}
